/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extra_Session_Error_Quota_Not_ReachedInputs */

const fr_extra_session_error_quota_not_reached = /** @type {(inputs: Extra_Session_Error_Quota_Not_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il te reste encore des séances, sur cette période ou en réserve.`)
};

/**

* @param {Extra_Session_Error_Quota_Not_ReachedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const extra_session_error_quota_not_reached = /** @type {((inputs?: Extra_Session_Error_Quota_Not_ReachedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extra_Session_Error_Quota_Not_ReachedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_extra_session_error_quota_not_reached(inputs)
});